import { createStore } from 'vuex'
// import {storage , sessionStorage} from '@/utils/storage';
import router from '@/router'
export default createStore({
  state: {
    //读取state值
    counter: 9,
    hasRoutes: false,
    activePath: '/dashboard',
    editableTabsValue: '/dashboard',
    editableTabs: [
      {
        title: '控制台',
        name: '/dashboard'
      }
    ],

    // ✅ 新增以下字段
    token2: null,
    userInfo2: null,
    menuList: null
  },
  getters: {
    // 触发getters中的某个方法
    GET_INFO: (state) => {
      return state.counter * state.counter
    },
    GET_TOKEN: state => {
      return JSON.parse(sessionStorage.getItem("token2") || '0');
    },
    GET_MENULIST: state => {
      return JSON.parse(sessionStorage.getItem("menuList") || '0');
    },
    GET_USERINFO: state => {
      return JSON.parse(sessionStorage.getItem("userInfo") || '0');
    },
    GET_LOGINIP: state => {
      return sessionStorage.getItem("loginIP") || '0';
    }
  },
  mutations: {
    // 触发mutations中的某个方法
    // store.commit('GET_ADMININFO')
    GET_ADMININFO: () => {
    },
    SET_TOKEN: (state, token2) => {
      state.token2 = token2; // ✅ 更新 state
      sessionStorage.setItem("token2", JSON.stringify(token2));
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo2 = userInfo; // ✅ 更新 state
      sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
    },

    SET_LOGINIP: (state, loginIP) => {
      sessionStorage.setItem("loginIP", loginIP);
    },

    SET_ACTIVEPATH: (state, path) => {
      state.activePath = path
    },
    SET_MENULIST: (state, menuList) => {
      sessionStorage.setItem("menuList", JSON.stringify(menuList));
    },

    SET_ROUTES_STATE: (state, hasRoutes) => {
      state.hasRoutes = hasRoutes
    },
    ADD_TABS: (state, tab) => {
      if (state.editableTabs.findIndex(e => e.name === tab.menuUrl) === -1) {

        state.editableTabs.push({
          title: tab.menuName,
          name: tab.menuUrl
        })
      }
      state.editableTabsValue = tab.menuUrl
    },
    RESET_TABS: (state) => {
      state.editableTabsValue = '/dashboard';
      state.editableTabs = [
        {
          title: '控制台',
          name: '/dashboard'
        }
      ]
    },
  },
  actions: {
    // 触发action中的方法
    // store.dispatch('logout')
    // 安全退出
    logout() {
      window.sessionStorage.clear();
      // router.push("/login")
      // router.push({
      //   path: '/login',
      //   query: {
      //     date: new Date().getTime()
      //   }
      // })
    },

    initStore({ commit }) {
      const token2 = sessionStorage.getItem("token2");
      if (token2) commit('SET_TOKEN', JSON.parse(token2)); // ✅ 恢复 token2

      const userInfo = sessionStorage.getItem("userInfo");
      if (userInfo) commit('SET_USERINFO', JSON.parse(userInfo)); // ✅ 恢复 userInfo
    }
  },
  modules: {
  }
})
